import React, {useEffect} from 'react';
import { Box } from "@mui/system";
import ErrorListView from "./ErrorListView";
import Header from "../../common/header/Header";
import Breadcrumb from "../../common/header/Breadcrumb";

const ErrorLogs = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Box sx={{ flexGrow: 1, backgroundColor: "#f7f9fa", minHeight: "100vh" }}>
        <Header />
        <Breadcrumb />
        <ErrorListView />
      </Box>
    </>
  );
};
export default ErrorLogs;
